import {useEffect,useState} from 'react';
import {mostrarEnums, mostrarEnumsSinoEsta} from "../redux/reducers/enumsReducers";
import {translateText} from "../helpers";
import {useAppDispatch, useAppSelector} from "../redux/hooks";

export function useEnums(group:string) {
    const {list:enumGroups,status} = useAppSelector(state => state.enums)
    const dispatch = useAppDispatch();
    const [enums, setEnums] = useState([]);

    useEffect(()=>{
            dispatch(mostrarEnumsSinoEsta());
    },[dispatch])
    useEffect(()=>{
        let items = enumGroups[group];
        if(items){
            setEnums(items.map((e:any)=>({...e,value: translateText(e.value) })));
        }
    },[group,setEnums,enumGroups])


    return enums;
}
